import Blue from '~/core'

new Blue({
  name: 'Tabs',
  selector: '.tabs',
  setup(tabs) {
    const triggersWrap = tabs.querySelector('.tabs__triggers')
    const triggers = [...tabs.querySelectorAll('.tabs__trigger')]
    const contents = [...tabs.querySelectorAll('.tabs__content')]
    const toggleEvents = 'click.prevent enter.prevent space.prevent'
    const overflow = tabs.querySelector('.tabs__overflow')

    if (triggers.length > 0) {
      triggers[0].classList.add('is-active')
    }

    if (triggers.length === 1) {
      triggers[0].style.display = 'none'
    }
    contents.forEach((el) => {
      if (el.getAttribute('data-id') === triggers[0].getAttribute('data-id')) el.classList.add('is-active')
    })

    const revealContent = (item) => {
      let parent = item.closest('.tabs__triggers')

      if (item.classList.contains('is-active')) {
        parent.classList.toggle('is-open')
      } else {
        let triggerId = item.getAttribute('data-id')
        let foundContent = null

        triggers.forEach((el) => {
          el.classList.remove('is-active')
        })
        contents.forEach((el) => {
          el.classList.remove('is-active')
          let contentId = el.getAttribute('data-id')
          if (contentId === triggerId) {
            foundContent = el
          }
        })

        item.classList.add('is-active')
        parent.classList.toggle('is-open')
        if (foundContent) {
          foundContent.classList.add('is-active')
        }
      }
    }

    triggersWrap.onscroll = function () {
      if (triggersWrap.scrollLeft > 0) {
        overflow.classList.add('indicator-left')
      } else {
        overflow.classList.remove('indicator-left')
      }
      if (Math.ceil(triggersWrap.scrollLeft) >= triggersWrap.scrollWidth - triggersWrap.clientWidth) {
        overflow.classList.remove('indicator-right')
      } else {
        overflow.classList.add('indicator-right')
      }
    }

    //init
    if (triggersWrap.clientWidth >= triggersWrap.scrollWidth) {
      triggersWrap.classList.add('no-overflow')
    } else {
      overflow.classList.add('indicator-right')
    }
    triggers.forEach((trigger) => {
      this.$addEvents(trigger, toggleEvents, () => revealContent(trigger))
    })
  },
})
